module.exports = __webpack_public_path__ + "assets/img/title-45087641.png";